// Deutschland
export default {
	status: {
		400: "Anforderung fehlgeschlagen! Bitte versuchen Sie es später erneut",
		401: "Anmeldesitzung abgelaufen! Bitte melden Sie sich erneut an",
		403: "Aktueller Account hat keine Zugriffsberechtigung",
		404: "Die Ressource, auf die Sie zugreifen möchten, existiert nicht",
		405: "Falsche Anforderungsmethode! Bitte versuchen Sie es später erneut",
		408: "Anforderungstimeout! Bitte versuchen Sie es später erneut",
		500: "Dienst hat eine Ausnahme festgestell",
		990: "Ihr Konto wurde wegen unerledigter Aufgaben für eine lange Zeit eingefroren",
		10030008: "Bitte geben Sie den Unterstützungsfonds zurück, bevor Sie eine Barauszahlung beantragen",
		10030010: "Einladungscode existiert nicht",
		10030011: "Überschritten die maximale Anzahl der Check-in-Zeiten",
		10030012: "Nicht den Check-in-Bedingungen entsprechen, bitte erledigen Sie die Aufgabe zuerst",
		10030013: "Fehler bei der Anmeldekonfiguration, bitte kontaktieren Sie den Kundenservice",
		10030014: "Nicht im erlaubten Zeitraum",
		10030015: "Mitglied existiert nicht",
		10030016:
			"Lieber Benutzer: Herzlichen Glückwunsch! Sie haben 100 % Ihrer Produktwerbung erfolgreich abgeschlossen. Bitte kontaktieren Sie den Plattform-Support, um eine Zurücksetzung anzufordern.",
		10030017: "Produkt kann nicht abgeglichen werden, bitte kontaktieren Sie den Kundenservice",
		10030018: "Unzureichendes Kontoguthaben",
		10030019: "Konto wurde deaktiviert",
		10030020: "Konto darf nicht handeln",
		10030021: "Kontoauszahlung untersagt",
		10030022: "Fehler im Transaktionspasswort",
		10030023: "Das Abhebungskonto ist nicht gebunden, bitte binden Sie zuerst das Abhebungskonto",
		10030024: "Fehler im alten Passwort",
		10030027: "Ihre Auszahlung ist eingeschränkt. Bitte kontaktieren Sie den Kundenservice für weitere Details",
		10030028: "Niedrige Kreditpunktzahlen verhindern das Abheben von Geld",
		10030030: "Nicht im erlaubten Zeitraum",
		10030031: "Bitte kontaktieren Sie den Kundendienst, um die heutige Aufgabe zurückzusetzen",
		10030050: "Die Bestellung ist abgelaufen. Bitte kontaktieren Sie den Kundenservice zur Bearbeitung."
	},
	errorHandler: {
		InternalError: "Interner Fehler im JavaScript-Engine",
		ReferenceError: "Objekt nicht gefunden",
		TypeError: "Falscher Typ oder falsches Objekt verwendet",
		RangeError: "Parameter außerhalb des Bereichs bei Verwendung von integrierten Objekten",
		SyntaxError: "Syntaxfehler",
		EvalError: "Falsche Verwendung von Eval",
		URIError: "URI-Fehler",
		UnknownError: "Unbekannt"
	},
	Network: {
		timedout: "Anforderungstimeout! Bitte versuchen Sie es später erneut",
		error: "Netzwerkfehler! Bitte versuchen Sie es später erneut"
	},
	request: {
		NoMoreData: "Keine weiteren Daten",
		OnlyImage: "Bitte laden Sie nur Bilddateien hoch.",
		FileMaxSize: "Die Dateigröße überschreitet den maximalen Wert von {0}M"
	},
	response: {
		loading: "Laden",
		success: "Erfolg",
		fail: "Fehlschlagen",
		complete: "Vollständig"
	},
	page: {
		noVerify: "Wallet nicht verifiziert, bitte verifizieren Sie zuerst Ihr Wallet",
		notexist: "Entschuldigung, die Seite, auf die Sie zugreifen möchten, existiert nicht~"
	}
};
